import { definePreset } from '@primeng/themes';
import Material from '@primeng/themes/material';
import { Preset } from '@primeng/themes/types';

import { baseTheme } from '../shared/base-theme';

/** San Antonio show — gold / tan primary ramp. */
export const SanAntonioPreset: Preset<any> = definePreset(Material, {
  ...baseTheme,
  semantic: {
    ...baseTheme.semantic,
    primary: {
      50: '#faf6e9',
      100: '#f0e6b9',
      200: '#e6d889',
      300: '#dcb959',
      400: '#d3ad32',
      500: '#a98b4f',
      600: '#8c7343',
      700: '#705938',
      800: '#55402c',
      900: '#3a2a21',
      950: '#21190f'
    }
  }
});
